import * as Yup from 'yup';

import maintenanceSchema from './maintenance';

const maintenanceFormSchema = Yup.object({
  maintenance: maintenanceSchema
});

export default maintenanceFormSchema;
export type MaintenanceFormSchema = ReturnType<
  typeof maintenanceFormSchema.cast
>;
